import React, { useState } from "react";
import Button from "../elements/Button/Button";

const ChatInput = ({
  onSendMessage,
  disabled = false,
  placeholder = "Type your answer...",
}) => {
  const [inputValue, setInputValue] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (inputValue.trim() && !disabled) {
      onSendMessage(inputValue.trim());
      setInputValue("");
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="flex items-center space-x-3 p-4 bg-white border-t border-gray-200"
    >
      <div className="flex-1">
        <textarea
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder={placeholder}
          disabled={disabled}
          className="w-full px-4 py-3 border border-gray-300 rounded-lg resize-none focus:ring-2 focus:ring-[#059669] focus:border-transparent text-sm"
          rows="1"
          style={{ minHeight: "48px", maxHeight: "120px" }}
        />
      </div>
      <Button
        type="submit"
        disabled={disabled || !inputValue.trim()}
        className={`px-6 py-3 text-white font-medium text-sm min-h-[48px] flex items-center ${
          disabled || !inputValue.trim()
            ? "bg-gray-400 cursor-not-allowed"
            : "bg-[#059669] hover:bg-[#047857]"
        }`}
      >
        Send
      </Button>
    </form>
  );
};

export default ChatInput;
